import { create } from "zustand";
import { AuthStore, UserInfo } from "../types";

export const useAuth = create<AuthStore>((set, get) => ({
  userInfo: {} as UserInfo,
  hasPermission: (permission: string) => {
    const { userInfo } = get();

    if (!userInfo || Object.keys(userInfo).length === 0) {
      return false;
    }

    return (
      permission === "all" || userInfo.profile.permissions.includes(permission)
    );
  },
  updateUserInfo: (userInfo: UserInfo) => set({ userInfo }),
}));
